import templates from './default';
export default templates;